import websiteHeaderLogoService from '../services/website-header-logo'
import {
  SET_WEBSITE_HEADER_LOGOS,
  SET_WEBSITE_HEADER_LOGO_ACTIVE,
  SET_WEBSITE_HEADER_LOGO_LOADING,
  SET_WEBSITE_HEADER_LOGO_ERROR,
  REMOVE_WEBSITE_HEADER_LOGO
} from '../mutation-types'

// State
export const state = {
  logos: [],
  activeLogo: null,
  loading: false,
  error: null
}

// Getters
export const getters = {
  websiteHeaderLogos: state => state.logos,
  activeWebsiteHeaderLogo: state => state.activeLogo,
  websiteHeaderLogoLoading: state => state.loading,
  websiteHeaderLogoError: state => state.error
}

// Mutations
export const mutations = {
  [SET_WEBSITE_HEADER_LOGOS](state, logos) {
    state.logos = logos
  },

  [SET_WEBSITE_HEADER_LOGO_ACTIVE](state, logo) {
    state.activeLogo = logo
  },

  [SET_WEBSITE_HEADER_LOGO_LOADING](state, loading) {
    state.loading = loading
  },

  [SET_WEBSITE_HEADER_LOGO_ERROR](state, error) {
    state.error = error
  },

  [REMOVE_WEBSITE_HEADER_LOGO](state, id) {
    state.logos = state.logos.filter(logo => logo.id !== id)
  }
}

// Actions
export const actions = {
  async fetchWebsiteHeaderLogos({ commit }) {
    commit(SET_WEBSITE_HEADER_LOGO_LOADING, true)
    commit(SET_WEBSITE_HEADER_LOGO_ERROR, null)
    try {
      const { data } = await websiteHeaderLogoService.getAllAdmin()
      commit(SET_WEBSITE_HEADER_LOGOS, data.data || [])
      return data
    } catch (error) {
      commit(SET_WEBSITE_HEADER_LOGO_ERROR, error.response?.data?.message || 'Failed to fetch website header logos')
      throw error
    } finally {
      commit(SET_WEBSITE_HEADER_LOGO_LOADING, false)
    }
  },

  async fetchActiveWebsiteHeaderLogo({ commit }) {
    commit(SET_WEBSITE_HEADER_LOGO_LOADING, true)
    commit(SET_WEBSITE_HEADER_LOGO_ERROR, null)
    try {
      const { data } = await websiteHeaderLogoService.getActive()
      commit(SET_WEBSITE_HEADER_LOGO_ACTIVE, data.data || null)
      return data
    } catch (error) {
      commit(SET_WEBSITE_HEADER_LOGO_ERROR, error.response?.data?.message || 'Failed to fetch active website header logo')
      throw error
    } finally {
      commit(SET_WEBSITE_HEADER_LOGO_LOADING, false)
    }
  },

  async activateWebsiteHeaderLogo({ commit, dispatch }, id) {
    commit(SET_WEBSITE_HEADER_LOGO_LOADING, true)
    try {
      const { data } = await websiteHeaderLogoService.activate(id)
      await dispatch('fetchWebsiteHeaderLogos')
      await dispatch('fetchActiveWebsiteHeaderLogo')
      return data
    } catch (error) {
      throw error
    } finally {
      commit(SET_WEBSITE_HEADER_LOGO_LOADING, false)
    }
  },

  async deleteWebsiteHeaderLogo({ commit, dispatch }, id) {
    commit(SET_WEBSITE_HEADER_LOGO_LOADING, true)
    try {
      const { data } = await websiteHeaderLogoService.delete(id)
      commit(REMOVE_WEBSITE_HEADER_LOGO, id)
      await dispatch('fetchActiveWebsiteHeaderLogo')
      return data
    } catch (error) {
      throw error
    } finally {
      commit(SET_WEBSITE_HEADER_LOGO_LOADING, false)
    }
  },

  async updateWebsiteHeaderLogoOrder({ commit, dispatch }, ids) {
    commit(SET_WEBSITE_HEADER_LOGO_LOADING, true)
    try {
      const { data } = await websiteHeaderLogoService.updateOrder(ids)
      await dispatch('fetchWebsiteHeaderLogos')
      return data
    } catch (error) {
      throw error
    } finally {
      commit(SET_WEBSITE_HEADER_LOGO_LOADING, false)
    }
  }
}
